import { createApolloClient } from './index';
export const client = createApolloClient();
